module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Down-left-76cb0cdb4f9380c62e6957bac1e59194.svg";